import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import ScrollToTop from './ScrollToTop';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';
import HomePage from './components/HomePage/HomePage';
import AboutUs from './components/AboutUs/AboutUs';
import Contact from './components/Contact/Contact';
// import Pricing from './components/Pricing/Pricing';
import Blog from './components/Blog/Blog';
import BlogDetail from './components/Blog/BlogDetail/BlogDetail';
import Register from './components/Register/Register';
import KVKK from './components/KVKK/KVKK';
import GizlilikSozlesmesi from './components/Legal/GizlilikSozlesmesi';
import KullaniciSozlesmesi from './components/Legal/KullaniciSozlesmesi';
import CerezPolitikasi from './components/Legal/CerezPolitikasi';
import AydinlatmaMetni from './components/Legal/AydinlatmaMetni';
import CookieBanner from './components/CookieBanner/CookieBanner';
import UserHeader from './components/User/Header/UserHeader';
import User from './components/User/User';
import UserFooter from './components/User/Footer/UserFooter';
import Topluluk from './components/Topluluk/Topluluk';
import Admin from './components/Admin/Admin';
import GaListener from './analytics/GaListener';

// import HastaLayout from './components/User/Hasta/Hasta';
// import HastaGenel from './components/User/Hasta/HastaGenel/HastaGenel';
// import HastaGenelAnlama from './components/User/Hasta/HastaGenel/HastaGenelAnlama/HastaGenelAnlama';
// import HastaGenelKonusma from './components/User/Hasta/HastaGenel/HastaGenelKonusma/HastaGenelKonusma';
// import HastaGenelOkuma from './components/User/Hasta/HastaGenel/HastaGenelOkuma/HastaGenelOkuma';
// import HastaGenelYazma from './components/User/Hasta/HastaGenel/HastaGenelYazma/HastaGenelYazma';
// import HastaGenelNasilCalisir from './components/User/Hasta/HastaGenel/HastaGenelNasilCalisir/HastaGenelNasilCalisir';
// import HastaGenelDenemeYap from './components/User/Hasta/HastaGenel/HastaGenelDenemeYap/HastaGenelDenemeYap';
// import HastaGorevler from './components/User/Hasta/HastaGorevler/HastaGorevler';
// import HastaKaynak from './components/User/Hasta/HastaKaynak/HastaKaynak';
// import HastaYardim from './components/User/Hasta/HastaYardim/HastaYardim';
// import Hastaistatistik from './components/User/Hasta/Hastaistatistik/Hastaistatistik';
// import HastaistatistikAnlama from './components/User/Hasta/Hastaistatistik/HastaistatistikAnlama/HastaistatistikAnlama';
// import HastaistatistikKonusma from './components/User/Hasta/Hastaistatistik/HastaistatistikKonusma/HastaistatistikKonusma';
// import HastaistatistikOkuma from './components/User/Hasta/Hastaistatistik/HastaistatistikOkuma/HastaistatistikOkuma';
// import HastaistatistikYazma from './components/User/Hasta/Hastaistatistik/HastaistatistikYazma/HastaistatistikYazma';
// import HastaAyarlar from './components/User/Hasta/HastaAyarlar/HastaAyarlar';

// import DoktorLayout from './components/User/Doktor/Doktor';
// import DoktorGenel from './components/User/Doktor/DoktorGenel/DoktorGenel';
// import DoktorGorevler from './components/User/Doktor/DoktorGorevler/DoktorGorevler';
// import DoktorAyarlar from './components/User/Doktor/DoktorAyarlar/DoktorAyarlar';
// import DoktorGenelHastaEkle from './components/User/Doktor/DoktorGenel/DoktorGenelHastaEkle';
// import DoktorGorevlerHastaEkle from './components/User/Doktor/DoktorGorevler/DoktorGorevlerHastaEkle';
// import DoktorGorevlerGorevAtama from './components/User/Doktor/DoktorGorevler/DoktorGorevlerGorevAtama';
// import DoktorGorevlerGorevEkle from './components/User/Doktor/DoktorGorevler/DoktorGorevlerGorevEkle';

// import UygulamaLayout from './components/User/Hasta/HastaUygulama/Uygulama';
// import UygulamaAnlama from './components/User/Hasta/HastaUygulama/Anlama/UygulamaAnlama';
// import UygulamaKonusma from './components/User/Hasta/HastaUygulama/Konusma/UygulamaKonusma';
// import UygulamaOkuma from './components/User/Hasta/HastaUygulama/Okuma/UygulamaOkuma';
// import UygulamaYazma from './components/User/Hasta/HastaUygulama/Yazma/UygulamaYazma';

// import Admin from './components/User/Admin/Admin';

function App() {

  return (
    <Router>
      <GaListener />
      <ScrollToTop />
      <CookieBanner />
      <div className="App">
        <Routes>
          <Route path="/" element={<><Header /><HomePage /><Footer /></>} />
          <Route path="/hakkimizda" element={<><Header /><AboutUs /><Footer /></>} />
          <Route path="/iletisim" element={<><Header /><Contact /><Footer /></>} />
          {/* <Route path="/fiyatlandirma" element={<><Header /><Pricing /><Footer /></>} /> */}
          <Route path="/blog" element={<><Header /><Blog /><Footer /></>} />
          <Route path="/blog/:slug" element={<><Header /><BlogDetail /><Footer /></>} />
          <Route path="/brodmann" element={<><Header /><Topluluk /><Footer /></>} />
          <Route path="/kvkk" element={<><Header /><KVKK /><Footer /></>} />
          <Route path="/gizlilik" element={<><Header /><GizlilikSozlesmesi /><Footer /></>} />
          <Route path="/kullanici-sozlesmesi" element={<><Header /><KullaniciSozlesmesi /><Footer /></>} />
          <Route path="/cerez-politikasi" element={<><Header /><CerezPolitikasi /><Footer /></>} />
          <Route path="/aydinlatma-metni" element={<><Header /><AydinlatmaMetni /><Footer /></>} />
          <Route path="/register" element={<><Header /><Register /><Footer /></>} />
          <Route path="/user" element={<><UserHeader /><User /><UserFooter /></>} />
          <Route path="/admin" element={<Admin />} />

          {/* <Route path="/user-hasta" element={<HastaLayout />}>
            <Route path="genel" element={<HastaGenel />} />
            <Route path="genel/anlama" element={<HastaGenelAnlama />} />
            <Route path="genel/konusma" element={<HastaGenelKonusma />} />
            <Route path="genel/okuma" element={<HastaGenelOkuma />} />
            <Route path="genel/yazma" element={<HastaGenelYazma />} />
            <Route path="genel/nasil-calisir" element={<HastaGenelNasilCalisir />} />
            <Route path="genel/deneme-yap" element={<HastaGenelDenemeYap />} />
            <Route path="gorevler" element={<HastaGorevler />} />
            <Route path="kaynak" element={<HastaKaynak />} />
            <Route path="yardim" element={<HastaYardim />} />
            <Route path="istatistik" element={<Hastaistatistik />} />
            <Route path="istatistik/anlama" element={<HastaistatistikAnlama />} />
            <Route path="istatistik/konusma" element={<HastaistatistikKonusma />} />
            <Route path="istatistik/okuma" element={<HastaistatistikOkuma />} />
            <Route path="istatistik/yazma" element={<HastaistatistikYazma />} />
            <Route path="ayarlar" element={<HastaAyarlar />} />
          </Route>

          <Route path="/user-doktor" element={<DoktorLayout />}>
            <Route path="genel" element={<DoktorGenel />} />
            <Route path="genel/hasta-ekleme" element={<DoktorGenelHastaEkle />} />
            <Route path="gorevler" element={<DoktorGorevler />} />
            <Route path="gorevler/hasta-ekleme" element={<DoktorGorevlerHastaEkle />} />
            <Route path="gorevler/gorev-atama" element={<DoktorGorevlerGorevAtama />} />
            <Route path="gorevler/gorev-atama/gorev-ekle" element={<DoktorGorevlerGorevEkle />} />
            <Route path="ayarlar" element={<DoktorAyarlar />} />
          </Route>

          <Route path="/uygulama" element={<UygulamaLayout />}>
            <Route path="anlama" element={<UygulamaAnlama />} />
            <Route path="konusma" element={<UygulamaKonusma />} />
            <Route path="okuma" element={<UygulamaOkuma />} />
            <Route path="yazma" element={<UygulamaYazma />} />
          </Route>

          <Route path="/user-admin" element={<Admin />}></Route> */}

        </Routes>
      </div>
    </Router>
  );
}

export default App;
